import { config, importFromJSON, exportToJSON, reduceLambdaObject, reduce } from "@jurinfor/lambda/core";
import { isLambdaJSON, StringToLambdaJSON, LambdaJSONToString } from "@jurinfor/lambda/json";
import { StringId, NumberId, ObjectId, SingletonId, UntypedArrayId, TypedArrayId, FormatTypeId, UnionId } from "@jurinfor/typing";
import { config as configProcess } from "@jurinfor/game-process";
import { CreateExcel } from "@jurinfor/js-excel";
import OrderFormProcess from "./ext-function/OrderFormProcess";
import ApplicationFormProcess from "./ext-function/ApplicationFormProcess";
import exportCell from "./ext-function/exportCell";
import makeReport from "./ext-function/makeReport";

import { colTypeNames, colTypeToString } from "./models/colTypeNames";
import tableTransformation from "./ext-function/tableTransformation";
import generateContextBySignature from "./ext-function/generateContextBySignature";
import { extractTableDataForContext, extractTableDataForContexts } from "./ext-function/extractTableDataForContext";
import { transpose, uniq, groups } from "./ext-function/tablefn";

Object.assign(config.FUNCTION_EXEC_CONTEXT, {
  ...{ StringId, NumberId, ObjectId, SingletonId, UntypedArrayId, TypedArrayId, FormatTypeId, UnionId },
  colTypeNames,
  colTypeToString,
  tableTransformation,
  generateContextBySignature,
  extractTableDataForContext,
  extractTableDataForContexts,
  transpose,
  uniq,
  groups,
  exportCell,
  makeReport,
  CreateExcel,
  OrderFormProcess,
  ApplicationFormProcess,
  isLambdaJSON,
  importFromJSON,
  exportToJSON,
  StringToLambdaJSON,
  LambdaJSONToString,
  reduceLambdaObject(obj) {
    const rl = configProcess.lambda.reduction;
    const result = reduceLambdaObject(obj, rl);
    if (!result) throw new Error('Could not reduce');
    return result;
  },
});

export default config;

